import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Services } from './pages/Services';
import { BoilerHire } from './pages/BoilerHire';
import { HeaterHire } from './pages/HeaterHire';
import { ChillerHire } from './pages/ChillerHire';
import { CoolingHire } from './pages/CoolingHire';
import { Ancillaries } from './pages/Ancillaries';
import { Contact } from './pages/Contact';
// Scroll to top on route change
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen flex flex-col font-sans text-gray-800 bg-white" data-id="element-2">
        <Header data-id="element-3" />
        <Routes data-id="element-4">
          <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
          <Route path="/about" element={<About data-id="element-8" />} data-id="element-7" />
          <Route path="/services" element={<Services data-id="element-10" />} data-id="element-9" />
          <Route path="/boiler-hire" element={<BoilerHire data-id="element-12" />} data-id="element-11" />
          <Route path="/heater-hire" element={<HeaterHire data-id="element-14" />} data-id="element-13" />
          <Route path="/chiller-hire" element={<ChillerHire data-id="element-16" />} data-id="element-15" />
          <Route path="/cooling-hire" element={<CoolingHire data-id="element-18" />} data-id="element-17" />
          <Route path="/ancillaries" element={<Ancillaries data-id="element-20" />} data-id="element-19" />
          <Route path="/contact" element={<Contact data-id="element-22" />} data-id="element-21" />
        </Routes>
        <Footer data-id="element-23" />
      </div>
    </BrowserRouter>;
}